<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>台泥碳學院</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <p>人才是企業永續營運的重要基礎，台泥致力於培育同仁多元發展，以期發揮其最大的潛力並透過績效評核等方式確認教育訓練之成效，同時兼顧淨零轉型過程中協助同仁得以從事新創造出來的綠色工作或者具備再就業的新知識與能力。</p>
        <p>台泥 2023 年開設「碳學院」鼓勵員工精進加值，課程免費且提供完整的學習課程地圖，包括溫室氣體盤查、碳管理、工程碳足跡、範疇三等課程與工作坊。提供同仁利用公假學習專業技能，促進台泥跨產業同仁相互交流提升，協助同仁接軌最新國際永續趨勢並能進一步考取具碳競爭力之相關認證。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="sectTit">學習課程地圖</div>
        <div class="contOver">
          <img class="map" src="@/assets/justTransitionCarbonCollege/pic2_01.png" />
        </div>
        <div class="employee">
          <div class="avatar">
            <img src="@/assets/justTransitionCarbonCollege/pic2_02.png" />
          </div>
          <div class="info">
            <div class="profile">
              <span class="age">年資 <span class="ageNum">24</span></span>
              <span class="name">蘇秀娟</span>
              <span class="exp">總經理室 副理</span>
            </div>
            <div class="tit">參與「溫室氣體盤查人才培訓課程」</div>
            <div class="desp">
              <div>身為電廠的一份子，「碳」是我們一定要知道的事，有時我擔心自己長期處在熟悉的舒適圈，會跟不上別人的腳步，所以當看到公司開設碳學院課程時我非常開心，主動爭取機會一定要去學習新知，由於跟我原本的工作領域完全不同，挑戰性很高，上課前先請教上過課的人，也準備了一些資料預習，最後順利通過考試，也希望碳學院之後可以再開設與碳捕捉、自然碳匯相關的課程。</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="sectTit">台泥碳學院課程</div>
        <swiper
          :modules = "modules"
          :slides-per-view="1"
          :space-between="1"
          :autoplay="{delay:3000, disableOnInteraction:false}"
          :speed="1000"
          :loop="true"
          :pagination="{clickable:true}"
          @swiper="onSwiper"
          @slideChange="onSlideChange"
          class="swiper"
        >
          <swiper-slide class="cover cover1"></swiper-slide>
          <swiper-slide class="cover cover2"></swiper-slide>
          <swiper-slide class="cover cover3"></swiper-slide>
          <swiper-slide class="cover cover4"></swiper-slide>
          <swiper-slide class="cover cover5"></swiper-slide>
          <swiper-slide class="cover cover6"></swiper-slide>
        </swiper>
      </div>
    </section>
    <section class="sect4">
      <div class="ctx">
        <div class="left">
          <div class="sectTit">和電壯世代轉攻綠能產業經驗傳承</div>
          <p>台泥企業團董事長張安平曾說：「21 世紀是能源的世紀，人類唯有乘坐綠電儲能的方舟，妥善儲存人類向大地借用的創能之箭，才能還給天地原有潔淨的樣貌。」</p>
          <p>因此台泥積極布建完整的綠色能源產業鏈，開發風力、太陽能光電等多元再生能源案場，並投入前瞻能源地熱開發與海洋溫差研究。</p>
          <p>然而發展綠能不僅需要具備專業知識，現場建置施工更是關鍵，台泥企業團看重旗下和平電力 20 餘年培養出之電力人才，調任電廠壯世代主管至台泥綠能，利用自身充足的電網知識與建置經驗輔佐綠能年輕團隊茁壯，也開啟職涯第二春。</p>
        </div>
        <div class="right">
          <div class="imgContainer4-1"></div>
        </div>
        <div class="clear"></div>
        <div class="employee">
          <div class="avatar">
            <img src="@/assets/justTransitionCarbonCollege/pic4_02.png" />
          </div>
          <div class="info">
            <div class="profile">
              <span class="age">年資 <span class="ageNum">26</span></span>
              <span class="name">林志堅</span>
              <span class="exp">台泥綠能 經理 (和平電力 23 年，台泥綠能 3 年)</span>
            </div>
            <div class="tit">“原來綠能的世界這麼大”</div>
            <div class="desp">
              <div>在和平電力 23 年，電廠內的工作對我來說駕輕就熟，因緣際會轉調至台泥綠能，同樣都是「發電」，但綠能的挑戰可不小，這挑戰不再僅僅是面對器械，更需要處理案場中所遇到的人、事、物。</div>
              <div>全球的趨勢都是朝著淨零排放前進，台灣綠電開發目前還在初始階段，台泥企業團從光電、風力、地熱甚至計畫中的海洋溫差發電，真的是有學不完的東西，光是我現在負責的太陽能光電就能遇上各種不同的案場類型，代表有學習不完的新事務，這就是人生最好的歷練，有這樣職場轉職的經驗，讓我活到老、學到老，我也非常鼓勵不管是中生代或是新生代的同仁，有機會先替自己的未來搶得先機。</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

export default defineComponent({
  name: 'JustTransitionCarbonCollege',
  components: {
    Header,
    Footer,
    Swiper,
    SwiperSlide
  },
  setup() {
    const onSwiper = (swiper: any) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
      modules: [Navigation, Pagination, Scrollbar, A11y, Autoplay]
    };
  },
  data() {
    return {
    }
  },
  methods:{
  },
  mounted() {
    // let swiperPageination = (document.querySelector(".swiper-pagination") as HTMLElement).cloneNode(true);
    // (document.querySelector(".swiper") as HTMLElement).after(swiperPageination);    

    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover1") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover2") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover3") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover4") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover5") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".swiper .cover6") as HTMLElement, 0.55);
    new ImgContainerAutoResize(document.querySelector(".imgContainer4-1") as HTMLElement, 0.8);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/justTransitionCarbonCollege/kv.webp");
  background-position: center bottom;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 p {
  line-height: 2em;
}

.sect2 {
  background: #fff;
}

.sect2 .sectTit {
  width: 350px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #fff;
  background: #63BFAA;
}

.sect2 .map {
  width: 1200px;
}

.sect2 .employee {
  margin: 40px 0 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect2 .employee .avatar {
  flex: 0 0 16%;
}

.sect2 .employee .avatar img {
  width: 100%;
  position: relative;
  z-index: 1;
}

.sect2 .employee .info {
  flex: 0 0 80%;
}

.sect2 .employee .info .profile .age {
  margin: 40px 20px 0 -90px;
  padding: 10px 10px 10px 50px;
  display: inline-block;
  position: relative;
  font-size: 16px;
  background: #F2C400;
  transform: translateY(-10px);
  overflow: visible;
}

.sect2 .employee .info .profile .age:after {
  content: "";
  display: inline-block;
  position: absolute;
  left: 100%;
  bottom: 0;
  border-style: solid;
  border-width: 47px 0 0 20px;
  border-color: transparent transparent transparent #F2C400;
}

.sect2 .employee .info .profile .age .ageNum {
  font-family: arial;
  font-weight: bold;
  font-size: 24px;
  color: #0C5F99;
}

.sect2 .employee .info .profile .name {
  margin: 0 10px;
  font-size: 24px;
}

.sect2 .employee .info .profile .exp {
  font-size: 15px;
}

.sect2 .employee .info .tit {
  margin: 10px 0;
  font-size: 22px;
  color: #0C5F99;
}

.sect2 .employee .info .desp {
  line-height: 1.6em;
  font-size: 16px;
}

.sect3 {
  background: #FCF2CB;
}

.sect3 .sectTit {
  margin: 0 0 20px;
  text-align: center;
  font-size: 36px;
}

.sect3 .swiper {
  border-radius: 30px;
}

.sect3 .swiper .swiper-wrapper {
  /* overflow: hidden; */
}

.sect3 .swiper .cover1 {
    background: url(../../assets/justTransitionCarbonCollege/carousel3_01.webp) center 20%;
    background-size: cover;
}

.sect3 .swiper .cover2 {
    background: url(../../assets/justTransitionCarbonCollege/carousel3_02.webp) center 75%;
    background-size: cover;
}

.sect3 .swiper .cover3 {
    background: url(../../assets/justTransitionCarbonCollege/carousel3_03.webp) center top;
    background-size: cover;
}

.sect3 .swiper .cover4 {
    background: url(../../assets/justTransitionCarbonCollege/carousel3_04.webp) center top;
    background-size: cover;
}

.sect3 .swiper .cover5 {
    background: url(../../assets/justTransitionCarbonCollege/carousel3_05.webp) center bottom;
    background-size: cover;
}

.sect3 .swiper .cover6 {
    background: url(../../assets/justTransitionCarbonCollege/carousel3_06.webp) center bottom;
    background-size: cover;
}

.sect3 .swiper .swiper-pagination {
  /* bottom: -40px !important; */
}

.sect3 .swiper .swiper-pagination .swiper-pagination-bullet {
  width: 15px;
  height: 15px;
  border: solid 1px #fff;
  background: #404040;
  opacity: 0.8;
}

.sect3 .swiper .swiper-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #fff;
}

/* .swiper-button-next:after {
  padding: 10px;
  font-size: 60px;
  background: #00000088;
} */

.sect4 {
    background: url(@/assets/justTransitionCarbonCollege/sectBack4.png), #F4F3F3;
    background-position: center, center;
    background-size: cover, cover;
}

.sect4 p {
  line-height: 2em;
}

.sect4 .left {
  width: 50%;
  margin: 20px 0;
  float: left;
}

.sect4 .left .sectTit {
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect4 .right {
  width: 45%;
  margin: 20px 0;
  float: right;
}

.sect4 .right .imgContainer4-1 {
  margin: 0 0 10px;
  border-radius: 30px;
  background: url(@/assets/justTransitionCarbonCollege/pic4_01.jpg) center;
  background-size: cover;
}

.sect4 .employee {
  margin: 20px 0 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect4 .employee .avatar {
  flex: 0 0 16%;
}

.sect4 .employee .avatar img {
  width: 100%;
  position: relative;
  z-index: 1;
}

.sect4 .employee .info {
  flex: 0 0 80%;
}

.sect4 .employee .info .profile .age {
  margin: 40px 20px 0 -90px;
  padding: 10px 10px 10px 50px;
  display: inline-block;
  position: relative;
  font-size: 16px;
  background: #F2C400;
  transform: translateY(-10px);
  overflow: visible;
}

.sect4 .employee .info .profile .age:after {
  content: "";
  display: inline-block;
  position: absolute;
  left: 100%;
  bottom: 0;
  border-style: solid;
  border-width: 47px 0 0 20px;
  border-color: transparent transparent transparent #F2C400;
}

.sect4 .employee .info .profile .age .ageNum {
  font-family: arial;
  font-weight: bold;
  font-size: 24px;
  color: #0C5F99;
}

.sect4 .employee .info .profile .name {
  margin: 0 10px;
  font-size: 24px;
}

.sect4 .employee .info .profile .exp {
  font-size: 15px;
}

.sect4 .employee .info .tit {
  margin: 10px 0;
  font-size: 22px;
  color: #0C5F99;
}

.sect4 .employee .info .desp {
  line-height: 1.6em;
  font-size: 16px;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect2 .employee .avatar {
    flex: 0 0 20%;
  }

  .sect2 .employee .info {
    flex: 0 0 75%;
  }

  .sect2 .employee .info .profile .age {
    margin: 40px 20px 0 -65px;
  }

  .sect4 .left {
    width: 100%;
    margin: 5px 0;
  }

  .sect4 .right {
    width: 80%;
    margin: 5px 10%;
  }

  .sect4 .employee .avatar {
    flex: 0 0 20%;
  }

  .sect4 .employee .info {
    flex: 0 0 75%;
  }

  .sect4 .employee .info .profile .age {
    margin: 40px 20px 0 -65px;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect2 .sectTit {
    width: 220px;
    top: -30px;
    font-size: 24px;
  }

  .sect2 .employee {
    margin: 40px 0 0;
  }

  .sect2 .employee .avatar {
    flex: 0 0 60%;
    margin: 0 20%;
  }

  .sect2 .employee .info {
    flex: 0 0 100%;
  }

  .sect2 .employee .info .profile .age {
    margin: 40px 20px 0 0;
    padding: 10px;
  }

  .sect3 .sectTit {
    font-size: 24px;
  }

  .sect4 .left {
    width: 100%;
    margin: 5px 0;
  }

  .sect4 .right {
    width: 100%;
    margin: 5px 0;
  }

  .sect4 .employee {
    margin: 40px 0 0;
  }

  .sect4 .employee .avatar {
    flex: 0 0 60%;
    margin: 0 20%;
  }

  .sect4 .employee .info {
    flex: 0 0 100%;
  }

  .sect4 .employee .info .profile .age {
    margin: 40px 20px 0 0;
    padding: 10px;
  }
}
</style>
